<template>
  <div v-if="service">
    <v-card class="mb-3" elevation="0">
      <v-card-title>Service "{{service.name}}"</v-card-title>
    </v-card>
    <v-card elevation="0">
      <v-card-title>Information général</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-flex>
              <v-text-field label="Nom du service" v-model="service.name" />
            </v-flex>
          </v-row>
          <v-row>
            <v-flex>
              <v-text-field label="Description" v-model="service.description" />
            </v-flex>
          </v-row>
          <v-row>
            <v-flex>
              <v-select v-model="service.api" label="API" :items="api"></v-select>
            </v-flex>
          </v-row>
          <v-row>
            <v-flex>
              <v-text-field
                :label="(service.type_id=='file')?'Prix par fichier':'Prix de base'"
                v-model="service.price"
                type="number"
              />
            </v-flex>
          </v-row>
          <v-row>
            <v-flex>
              <div class="text-capitalize overline text--secondary">Prix affiché</div>
              <ckeditor :editor="editor" v-model="service.priceLabel" :config="editorConfig"></ckeditor>
            </v-flex>
          </v-row>
          <v-row>
            <v-flex class="mb-4">
              <div class="text-capitalize overline text--secondary">Image</div>
              <file-upload v-model="service.image" />
            </v-flex>
          </v-row>
          <v-row>
            <v-flex>
              <div class="text-capitalize overline text--secondary">Page d'introduction</div>
              <editor v-model="service.intro" />
            </v-flex>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn class="primary" @click="save()">Sauver</v-btn>
        <v-btn @click="$router.push('/services/view/'+service.id+'/builder')">Lancer le builder</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import FileUpload from "@/components/FileUpload.vue";
import Editor from "@/components/Editor.vue";
export default {
  components: { FileUpload, Editor },
  data: function() {
    return {
      serviceId: null,
      service: null,
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the rich-text editor.
      }
    };
  },
  mounted: function() {
    this.initialize();
  },

  computed: {
    ...mapGetters("services", ["api"])
  },
  methods: {
    initialize() {
      if (this.$route.params.id) {
        this.serviceId = parseInt(this.$route.params.id);
        this.getService();
      } else {
        this.$router.push("/services");
      }
    },
    getService() {
      this.$store.dispatch("services/get", this.serviceId).then(() => {
        this.service = this.$store.getters["services/service"];
      });
    },
    updateIntro(newContent) {
      this.service.intro = newContent;
    },
    save() {
      this.$store.dispatch("services/update", this.service).then(() => {
        this.service = this.$store.getters["services/service"];
      });
    }
  }
};
</script>

<style>
</style>